import qs from 'qs'
import request from '@/utils/request'

// 会话存档查询接口（/qw-archive/**，对应后端 QiWeiArchiveController）
// 后端 QiWeiAuthWebConfig 拦截 /qw-archive/**：需携带接入方凭据 appId/appSecret 请求头

// 组装接入方鉴权请求头（app 来自 /qw-admin/app/list 返回的接入方对象）
export function archiveHeaders (app) {
    if (!app || !app.appId || !app.appSecret) {
        return {}
    }
    return { appId: app.appId, appSecret: app.appSecret }
}

// 查询参数清洗：剔除 null/undefined/空字符串，避免后端收到无意义的空值
// （注意：updateApp 的 chatIds 空串是"改为全部群"的业务语义，不走此清洗）
function cleanParams (params) {
    const result = {}
    Object.keys(params || {}).forEach(key => {
        const value = params[key]
        if (value !== null && value !== undefined && value !== '') {
            result[key] = value
        }
    })
    return result
}

// 客户群列表：name 群名模糊 / owner 群主 userid / 分页参数
export function getGroupList (params, app) {
    return request({
        url: '/qw-archive/group/list',
        method: 'post',
        data: qs.stringify(cleanParams(params)),
        headers: archiveHeaders(app)
    })
}

// 客户群详情（含成员列表）：成员 type 1 企业成员 2 外部联系人
export function getGroupDetail (chatId, app) {
    return request({
        url: '/qw-archive/group/detail',
        method: 'post',
        data: qs.stringify({ chatId }),
        headers: archiveHeaders(app)
    })
}

// 消息分页查询：roomId/fromUserid/fromType/msgtype/content 关键字/startTime/endTime（毫秒时间戳）
export function getMessagePage (params, app) {
    return request({
        url: '/qw-archive/message/page',
        method: 'post',
        data: qs.stringify(cleanParams(params)),
        headers: archiveHeaders(app)
    })
}

// 群维度消息统计：roomid/msgCount/externalCount/firstMsgtime/lastMsgtime + groupName
export function getMessageRooms (app) {
    return request({
        url: '/qw-archive/message/rooms',
        method: 'post',
        headers: archiveHeaders(app)
    })
}

// 手动触发拉取存档消息（返回新入库条数）
export function triggerPull (app) {
    return request({
        url: '/qw-archive/trigger/pull',
        method: 'post',
        headers: archiveHeaders(app)
    })
}

// 手动触发同步客户群（返回群数）
export function triggerGroupSync (app) {
    return request({
        url: '/qw-archive/trigger/groupSync',
        method: 'post',
        headers: archiveHeaders(app)
    })
}

// 存档拉取状态：seq 游标 / lastPullTime / lastPullCount / totalCount
export function getArchiveStatus (app) {
    return request({
        url: '/qw-archive/status',
        method: 'post',
        headers: archiveHeaders(app)
    })
}

// 媒体文件下载地址（GET 请求，凭据走 URL 参数，供 window.open 直接下载）
export function buildMediaDownloadUrl (fileid, fileName, app) {
    const query = qs.stringify({
        fileid,
        fileName: fileName || 'media',
        appId: app ? app.appId : '',
        appSecret: app ? app.appSecret : ''
    })
    return `/qw-archive/media/download?${query}`
}
